export default function disableCopyPast() : void {
    const $elements = document.querySelectorAll<HTMLElement>('.js-disable-copy-paste');

    $elements.forEach($el => {
        $el.addEventListener('paste', evt => evt.preventDefault());
    });
}
